import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../../services/apis";

export function* handleFetchClients({ payload }) {
  try {
    const res = yield call(API.fetchCompaniesForFilter, payload);
    const { data } = res;
    yield put(actions.fetchClientsSuccess(data));
  } catch (err) {
    yield put(actions.fetchClientsFailure(err?.response?.data));
  }
}

export function* handleFetchAllLabs({ payload }) {
  try {
    const res = yield call(API.fetchAllLabs, payload);
    const { data } = res;
    yield put(actions.fetchLabsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabsFailure(err?.response?.data));
  }
}

export function* handleFetchProjects({ payload }) {
  try {
    const res = yield call(API.fetchProjectCodesForFilters, payload.query);
    const { data } = res;
    yield put(actions.fetchProjectsSuccess(data));
  } catch (err) {
    yield put(actions.fetchProjectsFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* filtersSaga() {
  yield takeLatest(actions.fetchClients.type, handleFetchClients);
  yield takeLatest(actions.fetchProjects.type, handleFetchProjects);
  yield takeLatest(actions.fetchLabs.type, handleFetchAllLabs);
}
